<template>
  <div style="z-index: -1" class="absolute bottom-72 right-24">
    <img src="../../../assets/images/circle-sm.png" alt="circle-sm" />
  </div>
</template>
